import { bindUrl, request } from "./request";

export function noticeRead(id) {
  return request({
    url: bindUrl("/svc-notice/notice/read?id=" + id),
    method: "POST"
  });
}

export function noticePage(queryParams) {
  return request({
    url: bindUrl("/svc-notice/notice/page", {}),
    method: "GET",
    params: queryParams
  });
}

export function noticeDetail(queryParams) {
  return request({
    url: bindUrl("/svc-notice/notice/detail", {}),
    method: "GET",
    params: queryParams
  });
}

export function getUnreadNum() {
  return request({
    url: bindUrl("/svc-notice/notice/getUnreadNum?classification=OIL", {}),
    method: "GET"
  });
}
